export default __webpack_public_path__ + "static/2-2--0cf1d44bbc79563626e98adfeb94d180.png";